// extracted by mini-css-extract-plugin
export default {"item":"TodoItems_item__HDqSR","checkbox":"TodoItems_checkbox__Jdej3","textInput":"TodoItems_textInput__U6auS"};